import React from 'react';
import styled from 'styled-components';
import { PoliceReportsService } from '../../services/police-reports-service';

const Title = styled.h3`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 20px;
    font-family: ${props => props.theme.font.family};
    font-size: ${props => props.theme.font.size.large};
    font-style: ${props => props.theme.font.style};
    font-weight: ${props => props.theme.font.weight.regular};
`;

const Input = styled.input`
    width: 100%;
    padding: 15px;
    resize: none;
    margin: 5px;
    display: inline-block;  
    outline: 0;
    background: #f2f2f2;
    border: 0;
    border-radius: .25rem;
    box-sizing: border-box;
`;

const ChangePasswordFormContainer = styled.form`
      position: relative;
      margin: 0 auto 100px;
      text-align: center;
`;

const Button = styled.button`
    text-transform: uppercase;
    outline: 0;
    background: #3CAB3D;
    width: 100%;
    border: 0;
    padding: 15px;
    color: #FFFFFF;
    font-size: 14px;
    -webkit-transition: all 0.3 ease;
    transition: all 0.3 ease;
    cursor: pointer;
    border: none;
    border-radius: .25rem;
    padding: 15px 32px;  
    margin: .5rem;  
    margin-top: 2rem;
    text-align: center;  
    text-decoration: none;  
    display: inline-block;  
    font-size: 16px;  

  &:hover {
      background: #43A047;
  }

`;

const Message = styled.p`
  margin: 15px 0 0;
  color: #b3b3b3;
    font-size: ${props => props.theme.font.size.small};
    &:a {
      color: #4CAF50;
      text-decoration: none;
    }
`;

const ListItem = styled.li`
    text-align: left;
    padding-bottom: 1rem;
`;

interface UpdatePasswordFormProps {
    email: string;
    setEmail: (email: string) => void;
    emailError: string;
    setEmailError: (error: string) => void;
    setFormState: (state: 'login' | 'register' | 'changePassword') => void;
}

const UpdatePasswordForm: React.FC<UpdatePasswordFormProps> = ({email, setEmail, emailError, setEmailError, setFormState}) => {

    const validateEmail = (email: string) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    }

    const clickSendNewPassword = async () => {
        if (!validateEmail(email)) {
            setEmailError("Invalid email format");
            return;
        }

        try {
            await PoliceReportsService.updateUser(email);
            setFormState('login');
        } catch (error) {
            setEmailError("Failed to register user");
        }
    };

    return (
        <ChangePasswordFormContainer>
            <Title>Change Password</Title>
            <ul>
                <ListItem>Enter your email address to receive a password reset link.</ListItem>
            </ul>
            {emailError && <Message>{emailError}</Message>}
            <Input
                type="text"
                value={email}
                onChange={(e) => {
                    setEmail(e.target.value);
                    setEmailError("");
                }}
                placeholder="Email"
            />
            <Button onClick={clickSendNewPassword}>
                Get New Password
            </Button>
            <Message>
                <a href="#" onClick={() => setFormState('login')}>Cancel</a>
            </Message>
        </ChangePasswordFormContainer>
    );
}

export default UpdatePasswordForm;
